export default {
  apiKey: 'AIzaSyCcZaOanEn_t9_0i5EDt6uCMY8FhkG6yYI',
  authDomain: 'digi-clearance.firebaseapp.com',
  databaseURL: 'https://digi-clearance.firebaseio.com',
  projectId: 'digi-clearance',
  storageBucket: 'digi-clearance.appspot.com',
  messagingSenderId: '1000529845859'
}



// WEBPACK FOOTER //
// ./src/Config/FirebaseConfig.js